import PropTypes from "prop-types";
import React from "react";
import userStore from "data/userStore";
import StereotypesStore from "data/StereotypesStore";
import SearchFormStore from "data/SearchFormStore";
import useFluxStore from "@armus/use-flux-store";

export const InnerDefault = ({ magicName, defaultName=magicName, displayName }) =>
    <section className="welcome">
        <b>Hey, {displayName}. </b>
        Find an existing {defaultName} record with our search tools<br/>
        or create a new {magicName} record.
    </section>;

InnerDefault.propTypes = {
    displayName: PropTypes.string.isRequired,
    magicName: PropTypes.string.isRequired,
    defaultName: PropTypes.string,
};

const Default = props => {
    const {fluxContext} = props;
    const state = useFluxStore(() => {
        const availableKeys = SearchFormStore.getAvailableKeys(fluxContext);
        const magicRoot = StereotypesStore.getMagicRoot();
        const defaultKey = StereotypesStore.getDefaultKey();
        const magicName = availableKeys.includes(magicRoot.key)
            ? magicRoot.name
            : StereotypesStore.getStereotypeByKey(
                SearchFormStore.getKey(fluxContext)).name;
        const defaultName = availableKeys.includes(defaultKey)
            ? StereotypesStore.getStereotypeByKey(defaultKey).name
            : magicName;
        return {
            displayName: userStore.getDisplayName(),
            defaultName,
            magicName,
        };
    }, [
        userStore,
        SearchFormStore,
    ], [fluxContext]);
    return <InnerDefault {...state} />;
};

Default.propTypes = {
    fluxContext: PropTypes.string.isRequired,
};

export default Default;



// WEBPACK FOOTER //
// ./app/lib/dataentry/Default.js